import React from "react";
import FAQ from "../components/Faq";
import Footer from "../components/footer";
import Header from "../components/Header";
import Pricing from "../components/Pricing";

const Price = () => {
  return (
    <div className="h-full ">
      <div className=" bg-[#0d121e] h-full bg-cover font-thicboi px-6 md:px-20 py-10">
        <Header />
        <div className="flex flex-col  items-center  text-center gap-16 px-6 md:p-20">
          <Pricing />
        </div>
      </div>
      <FAQ fade={false}></FAQ>
      <Footer />
    </div>
  );
};

export default Price;
